<template>
  <div>
    <header class="inner-banner">
      <div class="container">
        <div class="row">
          <div class="inner-wrapper">
            <div class="col-md-12">
              <!-- Login -->
              <div class="container">
                <div class="card card-container">
                  <a href="/">
                    <img src="images/logo.png" alt="Logo" class="text-center" />
                  </a>
                  <div class="coach-verifcation-form">
                    <h2 style="padding: 10px 0 20px;">Reset Password</h2>
                  </div>
                  <BaseInput
                    :value="emailAddress"
                    placeholder="Enter your email to reset password"
                    @change="handleEmailChange"
                  />
                  <div class="d-flex-spc-btwn margin-t-1">
                    <BaseButton
                      type="primary"
                      class="btn btn-default reset-button"
                      @click="handleSendRequest"
                    >
                      SEND REQUEST
                    </BaseButton>
                    <BaseButton
                      type="primary"
                      class=" btn btn-default cancel-button"
                      @click="handleCancel"
                    >
                      Cancel</BaseButton
                    >
                  </div>
                  <div class="d-flex-spc-btwn">
                    <span class="pointer-hover" @click="handleLogin"
                      >Login</span
                    >
                    <span class="pointer-hover" @click="handleRegister"
                      >Register</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
const USER_STORE_KEY = "userStore";

export default {
  data() {
    return {
      emailAddress: ""
    };
  },
  methods: {
    handleEmailChange(e) {
      this.emailAddress = e.target.value;
    },
    handleSendRequest() {
      this.$store.dispatch(`${USER_STORE_KEY}/resetPassword`, {
        email: this.emailAddress
      });
    },
    handleCancel() {
      this.handleLogin();
    },
    handleLogin() {
      this.$router.push("/login");
    },
    handleRegister() {
      this.$router.push("/register");
    }
  }
};
</script>

<style></style>
